/* src/app/account/partials/depot-section/depot-section.component.scss */
/*# sourceMappingURL=depot-section.component.css.map */
